import { FormComponentProps } from "components/Form/components/FormComponentProps";
import { Input } from "components/Form/components/Input/Input";
import { Switch } from "components/Form/components/Switch/Switch";

export const SwitchFormComponent = ({ input, meta, fieldProps, fieldAttr }: FormComponentProps) => {
    if (fieldAttr?.hidden) return null;
    return (
        <Input fieldProps={fieldProps} fieldAttr={fieldAttr} input={input} meta={meta}>
            <Switch
                identifier={input.name}
                inputProps={input}
                attributes={fieldAttr}
                fieldProps={fieldProps}
            ></Switch>
        </Input>
    );
};
